var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ProbabilityOutlierConfig_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { BaseOutlierConfig } from './baseOutlierConfig';
import { ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
const schema = {
    $id: 'urn:wisepipe-common-pipe:ProbabilityOutlierConfig',
    type: 'object',
    properties: {
        contamination: { type: 'number', minimum: 0, maximum: 0.5 },
        threshold: { type: 'number', minimum: 0, maximum: 1 }
    },
    required: []
};
let ProbabilityOutlierConfig = ProbabilityOutlierConfig_1 = class ProbabilityOutlierConfig extends BaseOutlierConfig {
    constructor(toolType, column, newColumn, contamination, threshold, groupByColumns, customFormats) {
        super(toolType, column, newColumn, groupByColumns, customFormats);
        if (contamination !== undefined)
            this.contamination = contamination;
        if (threshold !== undefined)
            this.threshold = threshold;
        JSON.validate(this, ProbabilityOutlierConfig_1);
    }
    getOutput(iConfigHelper, ins) {
        return this.getOutputForOutlier(ins, true);
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        const inputs = new Map([[this.column, ['number']]]);
        this.addGroupByToInputs(inputs, this.groupByColumns);
        const newColumnName = this.newColumn === undefined ? 'Outlier' : this.newColumn;
        const outputs = [newColumnName, `${newColumnName} Probability`];
        return isSourceValid(source, inputs, outputs) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
ProbabilityOutlierConfig = ProbabilityOutlierConfig_1 = __decorate([
    JsonSchema(schema)
], ProbabilityOutlierConfig);
export { ProbabilityOutlierConfig };
//# sourceMappingURL=probabilityOutlierConfig.js.map